"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getObjectKeys_1 = require("../jsUtils/getObjectKeys");
var RomanValues = {
    M: 1000,
    CM: 900,
    D: 500,
    CD: 400,
    C: 100,
    XC: 90,
    L: 50,
    XL: 40,
    X: 10,
    IX: 9,
    V: 5,
    IV: 4,
    I: 1,
};
/**
 * @internal
 * Convert decimal numbers into roman numbers
 * @param decimal The decimal number that needs to be converted
 * @param isLowerCase if true the roman value will appear in lower case
 * @returns
 */
function convertDecimalsToRoman(decimal, isLowerCase) {
    var romanValue = '';
    for (var _i = 0, _a = (0, getObjectKeys_1.default)(RomanValues); _i < _a.length; _i++) {
        var i = _a[_i];
        var timesRomanCharAppear = Math.floor(decimal / RomanValues[i]);
        decimal = decimal - timesRomanCharAppear * RomanValues[i];
        romanValue = romanValue + i.repeat(timesRomanCharAppear);
    }
    return isLowerCase ? romanValue.toLocaleLowerCase() : romanValue;
}
exports.default = convertDecimalsToRoman;
//# sourceMappingURL=convertDecimalsToRomans.js.map